console.log('config.js begin');

const development = {
    postfix: ' - DEV',
    endpoints: {
        //api: 'https://api-gcm.genesysinnoapps.net/dev',
        api: 'https://kl1uxepzi9.execute-api.us-east-1.amazonaws.com/dev',
        kibana: ''
    }
};

const test = {
    postfix: ' - TEST',
    endpoints: {
        //api: 'https://api-gcm.genesysinnoapps.net/test',
        api: 'https://q1n75w5th7.execute-api.us-east-1.amazonaws.com/test',
        kibana: ''
    }
};

const production = {
    postfix: '',
    endpoints: {
        //api: 'https://api-gcm.genesysinnoapps.com/prod',
        api:'https://2hpfk3wf8b.execute-api.us-east-1.amazonaws.com/prod',
        kibana: ''
    }
};

const configuration = {
    clientID: '96368944-4b03-45cc-b180-732d0b3fcd59',

    integrationType: 'premium-app-monitoring', 
    appName: 'Genesys Cloud Monitoring',

    defaultEnvironment: 'mypurecloud.com',
    defaultLangTag: 'en-us',

    // Permissions required for running the Wizard App
    setupPermissionsRequired: ['admin'],

    // Set to false to disable self-service installation via the wizard
    installerEnabled: false,
    installerDisabledMessage: 'To enable the Genesys Cloud Monitoring product, please contact your Genesys sales representative or account team.',

    // These are the PureCloud items that will be added and provisioned by the wizard
    provisioningInfo: {
        roles: [
            // do not create for for non-premium app
            {
                name: 'Application',  // will compose full name below
                description: 'Generated role for application access',
                permissionPolicies: [{
                    domain: 'integration',
                    entityName: 'cloudMonitoring', 
                    actionSet: ['*'],
                    allowConditions: false
                }],
                type: 'application'

            }, {
                name: 'Server',
                description: 'Generated role for application server side operations',
                permissionPolicies: [{
                    domain: 'integration',
                    entityName: 'cloudMonitoring',
                    actionSet: ['*'],
                    allowConditions: false
                }, {
                    domain: 'integrations',
                    entityName: 'integration',
                    actionSet: ['view'],
                    allowConditions: false
                }, {
                    domain: 'telephony',
                    entityName: 'plugin',
                    actionSet: ['*'],
                    allowConditions: false
                }, {
                    domain: 'analytics',
                    entityName: 'userDetail',
                    actionSet: ['view'],
                    allowConditions: false
                }, {
                    domain: 'analytics',
                    entityName: 'conversationDetail',
                    actionSet: ['view'],
                    allowConditions: false
                }],
                type: 'server'
            }],
        oauth: [{
            name: 'Server',
            description: 'Generated client for application server side operations',
            authorizedGrantType: 'CLIENT_CREDENTIALS'
        }]

    }
};

const env = process.env.REACT_APP_CUSTOM_ENV.trim()
console.log('config.js, env = ', env)

let config;

if (env === 'production') {
    config = { ...production, ...configuration };
}
else if (env === 'test') {
    config = { ...test, ...configuration };
}
else {
    config = { ...development, ...configuration };
}

export { config };

['roles', 'oauth'].forEach(key => config.provisioningInfo[key].forEach(item => item.name = `${config.appName} ${item.name}${config.postfix}`));

//console.log('config.js, config = ', JSON.stringify(config, null, 3));
console.log('config.js end');
